export function updateSignalAlertData(state, alertId, updatedData = {}) {
  const oldData = state?.data?.data.signals || [];

  const newData = JSON.parse(JSON.stringify(oldData));

  const alertIndex = newData.findIndex((item) => item.id === alertId);

  if (alertIndex >= 0) {
    newData[alertIndex] = {
      ...newData[alertIndex],
      ...updatedData,
    };
  }

  const fullData = {
    ...state?.data,
    data: {
      ...state?.data.data,
      signals: [...newData],
    },
  };

  return fullData;
}
